//GeneratorFlag:[NoChange]
import { Server } from '@/core/server'
export default class PersonGradeService
{
	constructor(){}

	server(config)
	{
		return new Server(config)
	}

	//GeneratorFlag:[PersonGrade.Detail]
	async detail(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = false;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.get('/hub/person-grade/detail', {'params':params});
	};

	//GeneratorFlag:[PersonGrade.List]
	async list(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = false;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.get('/hub/person-grade/list', {'params':params});
	};

//GeneratorFlag:[NewAction]
}